import config from "config/config";
import { apiRequest, baseApiRequest } from "./apiInterceptor";

export class MessagesAPI {
  static async getMessagesSummary() {
    const result = await apiRequest.get(config.api.messages.summary()).send();
    return result.body;
  }

  static async fetchThreads(customerId: string) {
    return await apiRequest.get(config.api.messages.get(customerId)).send();
  }

  static async createUploadUrl(fileName: string, customerId: string) {
    return await apiRequest
      .post(config.api.messages.createUploadUrl())
      .send({ fileName, customerId });
  }

  static async uploadImageToS3(
    uploadUrl: string,
    file: File,
    contentType: string
  ) {
    // Read file as binary ArrayBuffer (same as Postman binary upload)
    const fileBuffer = await file.arrayBuffer();

    // Upload raw binary data to S3 using superagent
    // ArrayBuffer is supported directly in the browser
    return await baseApiRequest
      .put(uploadUrl)
      .set("Content-Type", contentType)
      .send(fileBuffer);
  }
}
